import { HttpClient } from '@angular/common/http';
import { inject, Service, Type } from '@angular/core';
import { cloneDeep } from 'lodash-es';

import { API_URL } from '@constants';
import {
  AnyResource,
  DownloadInfoMap,
  File,
  HistoryLogEntry,
  TimelineGroupedEntry,
} from '@models';
import { ModalData, ModalService } from './modal.service';

@Service()
export class HistoryService {
  appModalService = inject(ModalService);
  http = inject(HttpClient);

  getHistory = (params: Record<string, unknown>) =>
    this.http.get<TimelineGroupedEntry[]>(`${API_URL}/history`, {
      params: params as Record<string, string>,
    });

  getHistoryLog = (logId: string) =>
    this.http.get<Record<string, unknown>>(`${API_URL}/history/${logId}`);

  getDownloadInfo = (rid: number) =>
    this.http.get<DownloadInfoMap[]>(`${API_URL}/files/${rid}/downloads`);

  getLastOpenedFiles = (params: Record<string, unknown>) =>
    this.http.get<File[]>(`${API_URL}/files/lastopened`, {
      params: params as Record<string, string>,
    });

  getResourceHistory = (
    resourceType: string,
    rid: number,
    params: Record<string, unknown>
  ) =>
    this.http.get<HistoryLogEntry[]>(
      `${API_URL}/${resourceType}/${rid}/history`,
      {
        params: params as Record<string, string>,
      }
    );

  openModal = <T>(component: Type<T>, data?: ModalData<T>) =>
    this.appModalService.open(component, data ? cloneDeep(data) : data, {
      modalDialogClass: 'sm-modal',
    });

  openHistoryLog = async (log: HistoryLogEntry, resource: AnyResource) => {
    const { HistoryLogModalComponent } =
      await import('@shared/components/history/history-log-modal.component');

    return this.openModal(HistoryLogModalComponent, {
      log,
      resource,
    });
  };

  openHistory = async (resource: AnyResource) => {
    const { HistoryModalComponent } =
      await import('@shared/components/history/history-modal.component');

    return this.openModal(HistoryModalComponent, { resource });
  };
}
